import { useApi } from '../composables'
import http from '../composables/src/useHttp'

export const getAllTicketStatuses = () => {
  return useApi(http.get(`/settings/ticket-statuses`))
}
export const deleteTicketStatus = (id: string) => {
  return useApi(http.delete(`/settings/ticket-statuses/${id}`))
}
export const createTicketStatus = (data: any) => {
  return useApi(http.post(`/settings/ticket-statuses`, data))
}
export const updateTicketStatus = (id: string, data: any) => {
  return useApi(http.put(`/settings/ticket-statuses/${id}`, data))
}
export const updateTicketStatusPositions = (positions: { id: string; position: number }[]) => {
  return useApi(http.patch(`/settings/ticket-statuses/positions`, { positions }))
}
